<template>
  <div>
    <el-form
      size="small"
      :inline="true"
      :model="form"
      :label-position="labelPosition"
      :label-width="labelWidth"
      @submit.native.prevent
    >
      <el-form-item>
        <el-radio-group v-model="form.type">
          <el-radio label="sec">秒</el-radio>
          <el-radio label="msec">毫秒</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-input-number v-model="form.timestamp" controls-position="right" style="width: 200px"></el-input-number>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="fromTimestamp">时间戳转字符串</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="toTimestamp">字符串转时间戳</el-button>
      </el-form-item>
    </el-form>
    <el-input type="textarea" :autosize="autosize" v-model="form.timestr"></el-input>
  </div>
</template>

<script>
import { Message } from "element-ui";
export default {
  name: "Timestamp",
  data() {
    return {
      form: this.initform
    };
  },
  props: {
    labelPosition: {
      type: String,
      default: "left"
    },
    labelWidth: {
      type: String,
      default: "auto"
    },
    autosize: {
      type: Object,
      // ({ minRows: 5, maxRows: 35 }) equal {return { minRows: 5, maxRows: 35 }}
      default: () => ({ minRows: 5, maxRows: 35 })
    },
    initform: {
      type: Object,
      default: () => ({
        type: "msec",
        timestamp: new Date().getTime(),
        timestr: ""
      })
    }
  },
  methods: {
    fromTimestamp: function() {
      let timestamp = this.form.timestamp;
      if (this.form.type == "sec") {
        timestamp *= 1000;
      }
      let date = new Date(timestamp);
      let Y = date.getFullYear();
      let M = date.getMonth() + 1;
      M = M < 10 ? "0" + M : M;
      let D = date.getDate();
      D = D < 10 ? "0" + D : D;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      this.form.timestr = `${Y}-${M}-${D} ${h}:${m}:${s}`;
    },
    toTimestamp: function() {
      let timestamp = new Date(this.form.timestr).getTime();
      if (isNaN(timestamp)) {
        Message.error("无法识别的时间格式");
        return;
      }
      if (this.form.type == "sec") {
        timestamp = parseInt(timestamp / 1000);
      }
      this.form.timestamp = timestamp;
    }
  }
};
</script>

